import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface ICrossSellCategory {
    categories: ICategory[];
}

export interface ICategory {
    sku_id: string;
    position: number;
}

export interface ICrossSellCategoryData {
    skuId: string;
    position: number;
}

export class CrossSellCategory {
    @observable public skuId: string;
    @observable public position: number;

    public static fromJson(data: ICategory): CrossSellCategory {
        const newCrossSellCategory = new CrossSellCategory();
        if (!data) {
            return newCrossSellCategory;
        }

        const crossSellDataMapping = {
            skuId: data.sku_id.trim(),
            position: data.position
        };

        copyPropertiesExcludeNullsAndGetters(newCrossSellCategory, crossSellDataMapping);

        return newCrossSellCategory;
    }
}
